export default __webpack_public_path__ + "static/compareItemImg3-10ec5f500277f7de19490213176a9e8b.png";